export { default } from './SectionDescription';